// the values should be the nth powers of 2
export enum Onboarding {
  CODE_EDIT = 1, // 2^0
}
